<vectronic-card
  class="disabled-subsystems-dialog"
  [title]="getTitle()"
  [displayClose]="true"
  (closed)="dialogRef.close()"
>
  @if (disabledSubsystemNames?.length) {
    <ng-container body>
      <div class="disabled-subsystems-dialog__list">
        List of disabled subsystems:
        <ul>
          @for (disabledSubsystemName of disabledSubsystemNames; track disabledSubsystemName) {
            <li>
              {{ disabledSubsystemName }}
            </li>
          }
        </ul>
      </div>
    </ng-container>
  } @else {
    <ng-container body> None of them is disabled </ng-container>
  }
</vectronic-card>
